import $ from 'jquery';
import { Modal, FileInput } from 'rustig';

$(() => {
  $(".case-documents-drop-container").fileDragAndDrop({
    onFileDrop: function ($dropArea, files, e) {
      $dropArea.removeClass('over');

      if (files[1] != null) {
        Modal.openErrorModal("Only one document may be uploaded at a time.");
        return;
      }

      FileInput.storeDroppedFile({ file: files[0] });

      var $form = $('[data-file-drop]');
      $form.find('#filename').val(files[0].name);
      $form.find('#length').val(files[0].size);
      $form.remote();
    }
  });
}); 